import styled from 'styled-components';
import { Button } from 'shared/components/Button';
import { Modal } from 'shared/components/Modal';
import { variableFontRegular } from 'styles/theme/text';
import { t } from 'localization/utils/t';

const TP = 'checkout.components.Payment.GiftCardRemoveModal';

export const GiftCardRemoveModal = ({ onClickClose, onClickRemove }) => {
  return (
    <GiftCardRemoveModal.GiftCardModal
      onClose={onClickClose}
      title={t(`${TP}.modalTitle`, 'Remove GOAT Gift Card')}
    >
      <GiftCardRemoveModal.ModalSubtitle>
        {t(
          `${TP}.modalSubtitle`,
          'Are you sure you would like to remove your GOAT Gift Card from this order?',
        )}
      </GiftCardRemoveModal.ModalSubtitle>
      <Button
        onClick={onClickRemove}
        data-qa="remove_gift_card_button"
        title={t(`${TP}.remove`, 'Remove')}
      />
      <GiftCardRemoveModal.CancelRemoveGiftCardButton href="" onClick={onClickClose}>
        {t(`${TP}.cancel`, 'Cancel')}
      </GiftCardRemoveModal.CancelRemoveGiftCardButton>
    </GiftCardRemoveModal.GiftCardModal>
  );
};

GiftCardRemoveModal.CancelRemoveGiftCardButton = styled.a`
  text-decoration: underline;
  margin: 20px auto 0px auto;
`;

GiftCardRemoveModal.GiftCardModal = styled(Modal)`
  width: 200px;
`;

GiftCardRemoveModal.ModalSubtitle = styled.p`
  ${variableFontRegular({ size: '9.5px' })};
  margin-top: 10px;
`;
